import { ApiDtoInvoicing } from "src/dto/ApiDto";
import { CInvoicingGetInvoiceDetailsResponseType } from "../types";
import { CInvoicingCreateInvoiceForm } from "./CInvoicingCreateInvoiceForm";
import moment from 'moment';
import { KeyLabel } from "src/Library/Types";

export class CInvoicingGetInvoiceDetailsResponse implements CInvoicingGetInvoiceDetailsResponseType {
  constructor(json?: CInvoicingGetInvoiceDetailsResponseType) {
    Object.assign(this, json);
  }

  fromOrganisationId: string;

  fromOrganisationName: string;

  createdBy: string;

  toOrganisationId: string;

  toOrganisationName: string;

  shipmentNumber: string;

  shipmentId: number;

  bookingNumber: string;

  bookingId: number;

  mode: string;

  incoterm: string;

  type: string;

  billType: string;

  billNumber: number;

  invoiceNumber: string;

  invoiceDate: string;

  invoiceStatus: string;

  invoiceStatusToDisplay: string;

  fileLink: string;

  dueDate: string;

  terms: string;

  internalReferenceNumber: string;

  invoiceAmount: number;

  currency: string;

  tax: number;

  remarks: string;

  charges: typeof ApiDtoInvoicing.ChargeResponseDto[];

  dispute: typeof ApiDtoInvoicing.DisputeResponseDto;

  exchangeRates: typeof ApiDtoInvoicing.ExchangeRateResponseDto[];

  teams: { teamId: number; teamName: string; }[];

  isChargePresent: boolean;

  toInvoicingCreateInvoiceForm(): CInvoicingCreateInvoiceForm {
    return new CInvoicingCreateInvoiceForm({
      // sourceType: this.shipmentNumber ? 'shipment' : 'booking',
      // shipmentBookingId: this.shipmentNumber ||  this.bookingNumber,
      // shipmentId: this.shipmentNumber,

      // shipmentNumber: this.shipmentNumber,
      additionalComments: this.remarks,
      otherPartyId: this.toOrganisationId,
      invoiceType: this.type,
      billType: this.billType ?? undefined,
      billNumber: this.billNumber?.toString(),
      invoiceNumber: this.invoiceNumber,
      term: this.terms,
      invoiceDate: this.invoiceDate ? moment(this.invoiceDate) : undefined,
      internalReferenceNumber: this.internalReferenceNumber,
      invoiceAmount: this.invoiceAmount,
      invoiceCurrency: this.currency,
      gstAmount: this.tax,
      gstCurrency: this.currency || 'INR',
      mode: this.mode,
    });
  }

  toShipmentBookingIdPrefillOption(): KeyLabel | undefined {
    if (this.shipmentId) {
      return {
        key: this.shipmentId?.toString(),
        label: this.shipmentNumber,
      };
    }
    if (this.bookingId) {
      return {
        key: this.bookingId?.toString(),
        label: this.bookingNumber,
      };
    }
    return;
  }
}
